import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericModal from "@Shared/components/modals/generic-modal.vue";
import { SET_CLIENT_PROFILE_ACTIVE_STATUS } from "@Broker/@Modules/clients/board/store/board-actions";
import { mapActions } from "vuex";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReactivateModal",
  components: {
    GenericModal
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    boardId: {
      type: [String, Number],
      required: true
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", {
    SET_CLIENT_PROFILE_ACTIVE_STATUS
  })), {}, {
    async reactivate() {
      const button = $(this.$refs.reactivateButton);
      try {
        button.animateButton().animate("start");
        await this.SET_CLIENT_PROFILE_ACTIVE_STATUS({
          id: this.clientProfileId,
          status: true
        });
        button.animateButton().animate("finish", "success");
        this.hide();
        this.$router.push({
          name: "client-profile",
          params: {
            clientProfileId: this.clientProfileId,
            boardId: this.boardId
          }
        });
      } catch (e) {
        button.animateButton().animate("finish", "failed");
      }
    },
    show() {
      this.$refs.reactivateClient.show();
    },
    hide() {
      this.$refs.reactivateClient.hide();
    }
  })
});